export default __webpack_public_path__ + "static/media/remove.eca55f2a.svg";